import { TesseraBridge } from './TesseraBridge';

/**
 * La Hub del Bridge (I-609, Luca 11/10: «per adesso facciamolo comparire solo su hub di bridge»): col gioco attivo = Bridge la Hub non ha la riga
 * delle sezioni, ha SOLO la tessera «Prima mano e lezioni» (le sezioni le proporra' qbridge-orcb dopo: non se ne inventano). Una riga alta 48, sotto il
 * banner, dove le altre Hub hanno le schede: la Hub non scorre e non c'e' niente da riempire.
 *
 * ⚠️ Lo monta `HubSections` SOLO dentro il confronto LETTERALE del flag (che il bundler piega): questo file e il marcatore `data-hub-bridge` non sono in
 * produzione. La serratura (`useBridgeAperto`) e' DENTRO la tessera, come per l'ospite nella Hub.
 */
export function HubBridge() {
  return (
    <div data-hub-bridge className="flex min-h-0 flex-1 flex-col">
      <TesseraBridge />
    </div>
  );
}
